import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Menu, X, Ticket, LogOut } from 'lucide-react';

const AdminNav = ({ title, navItems = [], username, onLogout, titleIcon: TitleIcon }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <nav className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 lg:px-6 py-3 lg:py-4 flex justify-between items-center">
          <div className="flex items-center gap-2 min-w-0">
            {TitleIcon ? <TitleIcon className="h-5 w-5 text-accent flex-shrink-0" /> : <Ticket className="h-5 w-5 text-accent flex-shrink-0" />}
            <h1 className="text-base lg:text-2xl font-heading font-bold truncate">{title}</h1>
          </div>
          {/* Desktop nav */}
          <div className="hidden lg:flex items-center gap-3 flex-shrink-0">
            {navItems.map((item) => (
              <Button key={item.label} variant="ghost" onClick={item.onClick} data-testid={item.testId}>
                {item.icon && <item.icon className="h-4 w-4 mr-2" />}
                {item.label}
              </Button>
            ))}
            <span className="text-sm text-muted-foreground">Welcome, {username}</span>
            <Button variant="ghost" onClick={onLogout} data-testid="logout-btn">
              <LogOut className="h-4 w-4 mr-2" />Logout
            </Button>
          </div>
          {/* Mobile hamburger */}
          <button
            className="lg:hidden p-2 rounded-md hover:bg-muted transition-colors flex-shrink-0"
            onClick={() => setDrawerOpen(true)}
            data-testid="hamburger-btn"
            aria-label="Open navigation menu"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </nav>

      {/* Mobile Drawer */}
      {drawerOpen && (
        <div className="fixed inset-0 z-[100] lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setDrawerOpen(false)} />
          <div className="absolute left-0 top-0 h-full w-72 bg-white shadow-2xl flex flex-col">
            <div className="p-4 border-b border-border flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Ticket className="h-5 w-5 text-accent" />
                <span className="font-bold text-base">Desko Support</span>
              </div>
              <button
                className="p-1.5 rounded-md hover:bg-muted transition-colors"
                onClick={() => setDrawerOpen(false)}
                data-testid="close-drawer-btn"
                aria-label="Close menu"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-4 space-y-1">
              {navItems.map((item) => (
                <button
                  key={item.label}
                  onClick={() => { item.onClick(); setDrawerOpen(false); }}
                  className="w-full text-left flex items-center gap-3 py-3 px-3 rounded-lg hover:bg-muted transition-colors text-sm font-medium min-h-[44px]"
                  data-testid={item.testId}
                >
                  {item.icon && <item.icon className="h-5 w-5 text-muted-foreground flex-shrink-0" />}
                  {item.label}
                </button>
              ))}
            </div>
            <div className="p-4 border-t border-border space-y-2">
              <button
                onClick={() => { onLogout(); setDrawerOpen(false); }}
                className="w-full text-left flex items-center gap-3 py-3 px-3 rounded-lg hover:bg-red-50 text-red-600 transition-colors text-sm font-medium min-h-[44px]"
                data-testid="drawer-logout-btn"
              >
                <LogOut className="h-5 w-5 flex-shrink-0" />
                Logout
              </button>
              <p className="text-xs text-muted-foreground px-3">
                Welcome, <span className="font-medium">{username}</span>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminNav;
